import React from 'react'

import CruiseV1ItemCard from './CruiseV1ItemCard'
import CruiseV2ItemCard from './CruiseV2ItemCard'
import CustomCruiseItemCard from './CustomCruiseItemCard'
import { ItemCardVariant } from '../ItemCard'

import { CruiseItem } from 'tripPlanner/types/tripItem'
import { isCruiseV2, isLeBooking, isLeBookmark } from 'tripPlanner/utils'

interface Props {
  item: CruiseItem
  onClickCard: (offerLink: string) => void
  onClickTripName?: () => void
  variant: ItemCardVariant
}

export default function CruiseItemCard({
  item,
  onClickCard,
  onClickTripName,
  variant,
}: Props) {
  // Custom item
  if (item.sourceType === 'NA' || isLeBooking(item)) {
    return (
      <CustomCruiseItemCard
        item={item}
        onClickCard={onClickCard}
        onClickTripName={onClickTripName}
        variant={variant}
      />
    )
  }

  // LE Cruise item V1 & V2
  if (isLeBookmark(item)) {
    if (isCruiseV2(item)) {
      return (
        <CruiseV2ItemCard
          item={item}
          onClickCard={onClickCard}
          onClickTripName={onClickTripName}
          variant={variant}
        />
      )
    } else {
      return (
        <CruiseV1ItemCard
          item={item}
          onClickCard={onClickCard}
          onClickTripName={onClickTripName}
          variant={variant}
        />
      )
    }
  }

  return null
}
